import Cookie from "./cookie.js";
import m from "mithril";
import './base.css';
import './sidebar.css'


export default function TabController(vnode) {
  var expanded = false;
  return {
    oninit: function() {
    },
    selectTab: function(tabId) {
      expanded = false;
      Cookie.set("selectedTab", tabId);
      document.redraw(true);
    },
    selectedTab: function() {
      var tab = Cookie.get("selectedTab");
      return (tab && tab.length) ? tab : this.defaultTab;
    },
    defaultTab: "time",
    view: function(vnode) {
      var currentTabId = this.selectedTab()
      var tabs = vnode.attrs.tabs
      var menu = vnode.attrs.menu
      var selectedTab = tabs.filter(function(e){return e.id == currentTabId}).pop();
    
      if (!selectedTab) selectedTab = tabs[0];

      var content = m("div", {key:"tab-" + selectedTab.id, id:"tab-" + selectedTab.id, class:"tab-content"}, m(selectedTab.content))
      return m("div#tab-container", {key:"tab-" + selectedTab.id, class: expanded ? "expanded" : undefined},
        m('div.reload',  {onclick: function() { location.clearAndReload(); }}, ""),
        m(TabButton, {onclick:function(){expanded = !expanded}}),
        m(TabToolbar, {callback:this.selectTab, tabs:tabs, menu:menu, selectedTab: selectedTab}),
        content
      );
    }
  }
}

var TabButton = {
  view: function(vnode) {
    return m('div#sidebar-toggle', {onclick:vnode.attrs.onclick});
  }
}

var TabToolbar = {
  view: function(vnode) {

    var attrs = vnode.attrs
    var tabs = attrs.tabs
    var menu = attrs.menu
    var selectedTab = attrs.selectedTab
    var tabNodes = tabs.map(function(item) {
      var tab = m(TabItem, item)
      tab.attrs.selected = item.id == selectedTab.id;
      return tab;
    })
    if (menu) { tabNodes.push(m(Menu, menu)) }

    return m("div.tab-toolbar.bg-themeable.kindle-fullheight", {onclick:function(e) {
        var id = e.target.id;
        if (id) attrs.callback(e.target.id);
      }},
      tabNodes
    );
  }
}

var TabItem = {
  view: function(vnode) {
    var attrs = vnode.attrs
    return m('div.tab-item.bg-themeable',
      {class:attrs.selected ? "selected" : "", key:attrs.id, id:attrs.id, onclick:attrs.onclick}
      ,m('div.tab-icon.bg-themeable'), attrs.title
      )
  }
}